import React, { useEffect, useState } from 'react'
import { IoIosClose } from "react-icons/io";
import { BsCheck2 } from "react-icons/bs";
import { RiExpandLeftFill, RiExpandRightFill } from "react-icons/ri";
import { RxReset } from "react-icons/rx";

export default function Table({ object, handleTabelData, handleFormData, preview, tableData, data, formUse, viewOnly,rowIndex, colIndex }) {


    const [tableobject, setTableObject] = useState({})
    const [selectedRow, setSelectedRow] = useState(null)
    const [selectedColumn, setSelectedColumn] = useState(null)
    const [image, setImage] = useState(null)

    useEffect(() => {
        preview && preview ? setTableObject(object) :
            setTableObject({
                ...object, tableData: object?.tableData?.map((data) => {
                    return data?.map((each) => {
                        return { ...each, edit: false}
                    })
                })
            })
    }, [object, object.columnNames, object.columns, object.tableData, object.columnNames])

    useEffect(() => {
        formUse && handleFormData && handleFormData(object.content+"-"+rowIndex+colIndex, object.tableData.map((data, i) => {
            let obj = {}
            obj["row"] = i + 1
            object.columnsType.forEach((type, index) => {
                if (type === "toggle") {
                    obj[object.columnNames[index]] = false
                } else if (type === "input") {
                    obj[object.columnNames[index]] = ""
                } else {
                    obj[object.columnNames[index]] = data[index]["content"]
                }
            })
            return obj
        }))
    }, [])

    const handleEdit = (rowIndex, columnIndex) => {
        const tableData = { ...tableobject }
        setTableObject({
            ...tableobject, tableData: tableData.tableData.map((data, index) => {
                return index === rowIndex ? data.map((each, i) => {
                    return i === columnIndex ? { ...each, edit: true } : each
                }) : data
            })
        })
    }

    const handleChangeData = (e, rowIndex, columnIndex) => {
        const tableData = { ...tableobject }
        setTableObject({
            ...tableobject, tableData: tableData.tableData.map((data, index) => {
                return index === rowIndex ? data.map((each, i) => {
                    return i === columnIndex ? { ...each, content: e.target.value } : each
                }) : data
            })
        })
    }

    const handleCancel = (rowIndex, columnIndex) => {
        // tableData.tableData[rowIndex][columnIndex].edit = false
        setTableObject({
            ...tableobject, tableData: tableobject.tableData.map((data, index) => {
                return index === rowIndex ? data.map((each, i) => {
                    return i === columnIndex ? { ...each, edit: false, content: "text" } : each
                }) : data
            })
        })
    }
    const handleSave = (rowindex, colindex) => {
        // tableData.tableData[rowindex][colindex].edit = false
        handleTabelData(tableobject.id, tableobject.tableData)
        setTableObject({
            ...tableobject, tableData: tableobject.tableData.map((data, index) => {
                return index === rowindex ? data.map((each, i) => {
                    return i === colindex ? { ...each, edit: false } : each
                }) : data
            })
        })
    }

    const increaseRowSpan = () => {
      if (selectedRow !== null && selectedColumn !== null) {
        const tableData = { ...tableobject };

        // Increase the rowspan of the selected cell
        const updatedTableData = tableData.tableData.map((data, rowIndex) => {
          return data.map((cell, colIndex) => {
            if (rowIndex === selectedRow && colIndex === selectedColumn) {
              return { ...cell, rowspan: cell.rowspan + 1 };
            }
            return cell;
          });
        });

        // Adjust rowspan for subsequent rows in the same column
        let remainingRowspan =
          updatedTableData[selectedRow][selectedColumn].rowspan;
        const adjustedTableData = updatedTableData.map((data, rowIndex) => {
          if (rowIndex > selectedRow) {
            return data.map((cell, colIndex) => {
              if (colIndex === selectedColumn) {
                if (remainingRowspan > 1) {
                  remainingRowspan--;
                  return { ...cell, rowspan: 0 }; // Set rowspan to 0 for merged rows
                }
              }
              return cell;
            });
          }
          return data;
        });

        // Update the table object with the new rowspan values
        setTableObject({
          ...tableobject,
          tableData: adjustedTableData,
        });

        // Update the parent component with the new table data
        handleTabelData(
          tableobject.id,
          adjustedTableData
        );
      }
    };

    const increaseColSpan = () => {
      if (selectedRow !== null && selectedColumn !== null) {
        const tableData = { ...tableobject };

        // Increase the colspan of the selected cell
        const updatedTableData = tableData.tableData.map((data, rowIndex) => {
          return data.map((cell, colIndex) => {
            if (rowIndex === selectedRow && colIndex === selectedColumn) {
              return { ...cell, colspan: cell.colspan + 1 };
            }
            return cell;
          });
        });

        // Adjust colspan for subsequent cells in the same row
        const adjustedTableData = updatedTableData.map((data, rowIndex) => {
          if (rowIndex === selectedRow) {
            let remainingColspan =
              updatedTableData[selectedRow][selectedColumn].colspan;
            return data.map((cell, colIndex) => {
              if (colIndex > selectedColumn) {
                if (remainingColspan > 1) {
                  remainingColspan--;
                  return { ...cell, colspan: 0 }; // Set colspan to 0 for merged columns
                }
              }
              return cell;
            });
          }
          return data;
        });

        // Update the table object with the new colspan values
        setTableObject({
          ...tableobject,
          tableData: adjustedTableData,
        });

        // Update the parent component with the new table data
        handleTabelData(
          tableobject.id + "-" + selectedRow + selectedColumn,
          adjustedTableData
        );
      }
    };

    const handleResetSpan = () => { 
        if (selectedRow !== null && selectedColumn !== null) {
            const tableData = { ...tableobject }
            setTableObject({
                ...tableobject, tableData: tableData.tableData.map((data, index) => {
                    return index === selectedRow ? data.map((each, i) => {
                        return i === selectedColumn ? { ...each, rowspan: 1, colspan: 1 } : each
                    }) : data
                })
            })
        }
    }

    const handleFileChange = (e, rowIndex, columnIndex) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            const reader = new FileReader();
            reader.onloadend = () => {
                const tableData = { ...tableobject }
                let data = {
                  ...tableobject,
                  tableData: tableData.tableData.map((data, index) => {
                    return index === rowIndex
                      ? data.map((each, i) => {
                          return i === columnIndex
                            ? { ...each, src: reader.result }
                            : each;
                        })
                      : data;
                  }),
                };
                setTableObject(data)
                setImage(true)
                handleTabelData(tableobject.id, data.tableData)
            }
            reader.readAsDataURL(file);
        }
    }



    return (
        <div className='form_table_container'>
            <table style={{ width: "100%" }}>
                {object.showHeader && <thead className='form_table_header'>
                    <tr>
                        {tableobject?.columnNames?.map((columnName, index) => {
                            return <td key={index} style={{ border: "0.4px solid #D3D3D3", fontSize: `14px`, textWrap: "wrap" }} >{columnName}</td>
                        })}
                    </tr>
                </thead>}
                <tbody>
                    {tableobject?.tableData?.map((row, index) => {
                        return <tr key={index}>
                            {row.map((column, i) => {
                                return column.rowspan === 0 || column.colspan === 0 ? null : <td rowSpan={column?.rowspan} colSpan={column?.colspan} style={{ width: `fit-content`, maxWidth: "75%", border: `0.4px solid #D3D3D3`, textWrap:`${i === 1 ? "wrap" : "nowrap"}`, fontSize: `14px`, padding: "8px", position: "relative", textAlign: column?.textAlign || "start" }} key={i}
                                onMouseOver={(e) => {
                                        if (!preview && !viewOnly) {
                                            e.currentTarget.style.backgroundColor = "#f0f0f0";
                                            e.currentTarget.style.cursor = "pointer";
                                    }
                                    if (selectedRow !== index || selectedColumn !== i) {
                                        setSelectedRow(index);
                                        setSelectedColumn(i);
                                    }
                                }
                                }
                                onMouseOut={(e) => {
                                        if (!preview && !viewOnly) {
                                            e.currentTarget.style.backgroundColor = "white";
                                            e.currentTarget.style.cursor = "default";
                                    }
                                    }
                                }
                                >
                                    {selectedColumn === i && selectedRow === index && !preview && <>
                                        <RxReset style={{ position: "absolute", right: "2px", top: "2px", height: "10px", width: "10px" }} onClick={handleResetSpan}/>
                                        {/* { i !== (row.length - 1) && <RiExpandRightFill style={{ position: "absolute", right: "5px", top: "35%", height: "10px", width: "10px" }} onClick={increaseColSpan} />}
                                        {i !== 0 && <RiExpandLeftFill style={{ position: "absolute", left: "5px", top: "35%", height: "10px", width: "10px" }} onClick={increaseColSpan}/>}
                                        {index !== 0 && <RiExpandLeftFill style={{ position: "absolute", left: "50%", top: "2px", height: "10px", width: "10px", rotate: "90deg" }} onClick={increaseRowSpan} />} */}
                                        {index !== (tableobject.tableData.length - 1) && <RiExpandLeftFill style={{ position: "absolute", left: "50%", bottom: "2px", height: "10px", width: "10px", rotate: "-90deg" }} onClick={increaseRowSpan} />}
                                    </>
                                    }
                                    {object.columnsType[i] === "text" ?
                                    !preview && column.edit ?
                                        <div className='d-flex gap-1 align-items-center'>
                                            <textarea type='text' value={column.content} onChange={(e) => handleChangeData(e, index, i)} className='form-control' />
                                            <BsCheck2 color='green' style={{ height: "20px", width: "20px" }} onClick={() => handleSave(index, i)} />
                                            <IoIosClose color='red' style={{ height: "30px", width: "30px" }} onClick={() => handleCancel(index, i)} />
                                        </div> :
                                        <FixedText index={index} i={i} preview={preview} value={column.content} handleEdit={handleEdit} />
                                    : object.columnsType[i] === "toggle" ?
                                        <Toggle tableData={tableData && tableData} keyName={tableobject.columnNames[i]}
                                            tableName={tableobject.content +"-"+ rowIndex + colIndex}
                                            row={index}
                                            data={data && data[object?.content + "-"+ rowIndex + colIndex] && data[object?.content + "-"+ rowIndex + colIndex][index][object.columnNames[i]]}
                                            viewOnly={viewOnly}
                                            /> :
                                            object.columnsType[i] === "image" ?
                                                column?.src ?
                                                <img src={column.src} alt="table_image" style={{ width: "100px", height: "100%", objectFit: "cover", borderRadius: "8px" }} />
                                                :
                                                <input type="file" accept="image/*" style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "8px", cursor: "pointer" }} onChange={(e) => handleFileChange(e, index, i)} />
                                            :
                                        <TextInput tableData={tableData && tableData} keyName={tableobject.columnNames[i]}
                                            tableName={tableobject.content +"-"+ rowIndex + colIndex}
                                            row={index}
                                            data={data && data[object?.content + "-"+ rowIndex + colIndex] && data[object?.content + "-"+ rowIndex + colIndex][index][object.columnNames[i]]}
                                            viewOnly={viewOnly}
                                        />}
                                </td>
                            })}
                        </tr>
                    })}
                </tbody>
            </table>
        </div>
    )
}

const FixedText = (props) => {
    return (
        <div
            onClick={() => !props.preview && props.handleEdit(props.index, props.i)}
            style={{ whiteSpace: "pre-line" }}
        >
            {props.value}
        </div>
    );
}

const TextInput = ({ tableData, keyName, row, tableName, data, viewOnly }) => {
    return viewOnly ? <span style={{ borderRadius: "8px", fontSize: "12px", color: "gray" }}>{data}</span> : <input className='form-control'
        value={data && data}
        onChange={(e) => tableData && tableData(keyName, row, tableName, e.target.value)}
    />
}

const Toggle = ({ tableData, keyName, row, tableName, data, viewOnly }) => {
    return <div className="form-switch d-flex">
        <input className="form-check-input" style={{ width: "40px", height: "20px" }} type="checkbox" id="paymentTerms"
            checked={data && data}
            onChange={(e) => tableData && tableData(keyName, row, tableName, e.target.checked)}
            disabled={viewOnly}
        />
    </div>
}